import * as React from 'react';
const map = require('lodash/map');

import { DefaultPopularItem } from '../popular_item/default_popular_item';
import { ITopOffer, ITopJK } from '../../models/top_three';

const s = require('./popular_content.css');

interface IPopularContentProps {
  onItemClick(order: number): void;
  itemClass: React.ComponentClass<any>;
  offers: ITopOffer[] | ITopJK[];
}

const PopularContent = (props: IPopularContentProps) => {
  return (<div className="с-tabs-content">
    <div className="c-tabs-tab-content">
      <div className={`${s['c-popular-block-wrap']} cg-row`}>{
        map(props.offers, (offer: ITopOffer | ITopJK, i: number) => {
          return React.createElement(
            props.itemClass,
            Object.assign({}, {
              key: `offer-${i}`,
              position: i + 1,
              onClick: () => { props.onItemClick(i); },
            }, offer, {
              promoText: (i === 0) ? (offer as ITopJK).promoText : null,
            }),
          );
        })
      }{
        (!props.offers || props.offers.length < 3) && <DefaultPopularItem/>
      }</div>
    </div>
  </div>);
};

export { PopularContent }
